import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalFooter, ModalHeader } from "reactstrap"
import ModalBody from "reactstrap/es/ModalBody"

class CloseBox extends Component {
    constructor(props) {
        super(props)
        this.state = {
            closing: false,
            modal: false,
        }
    }

    _setModal = () => {
        this.setState({
            modal: !this.state.modal
        })
    }

    _handleConfirmClickClose = (e) => {
        e.preventDefault()

        const { box, barcodeError } = this.props
        const barcodes = barcodeError.find(item => item.boxID === box._id)

        this.setState({
            modal: barcodes !== undefined ? true : false
        }, () => {
            barcodes === undefined && this._handleClickClose()
        })
    }

    _handleClickClose = async () => {

        if (this.state.closing) return false

        const r = window.confirm('Bạn có chắc chắc muốn đóng thùng này?')
        if (!r) return false

        this.setState({
            closing: true,
            modal: false,
        })

        try {
            await this.props.onClose()

            this.setState({
                closing: false
            })
        } catch (e) {
            this.setState({
                closing: false,
            })
        }
    }

    render() {
        const { box, barcodeError, position } = this.props
        const barcodes = barcodeError.find(item => item.boxID === box._id)
        const { status } = box

        if (status !== 'opening') return null

        const { closing, modal } = this.state

        return (
            <div className={position === 'footer' ? "CloseBox card-footer" : "CloseBox"}>
                {position === 'footer' &&
                    <div className="d-flex justify-content-center">
                        <button disabled={closing} onClick={this._handleConfirmClickClose}
                            className="btn btn-success mx-2">
                            Đóng thùng
                        </button>
                    </div>
                }
                {position !== 'footer' &&
                    <button disabled={closing} onClick={this._handleConfirmClickClose}
                        className="btn btn-success mx-2">
                        Đóng thùng
                    </button>
                }
                {modal && (
                    <Modal isOpen={modal} toggle={this._setModal}>
                        <ModalHeader toggle={this._setModal}>Danh sách barcode quét sai</ModalHeader>
                        <ModalBody>
                            {barcodes !== undefined && barcodes.barcodes.length > 0 && (
                                <div>
                                    {barcodes.barcodes.map((item, index) => {
                                        return (
                                            <div className="mb-1" key={index}><strong>#{item}</strong></div>
                                        )
                                    })}
                                </div>
                            )}
                        </ModalBody>
                        <ModalFooter className="d-flex justify-content-between">
                            <Button color="default" onClick={this._setModal}>Hủy </Button>
                            <Button color="primary" onClick={this._handleClickClose}>Đóng thùng</Button>
                        </ModalFooter>
                    </Modal>
                )}
            </div>
        )
    }
}

CloseBox.propTypes = {
    box: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default CloseBox
